import React from 'react';

export const ProgressBar = ({ progress, className = '', showPercentage = true }) => {
  return (
    <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 flex items-center justify-center z-50 pointer-events-none">
      <div className={`w-11/12 max-w-4xl bg-gray-200 rounded-full h-8 ${className}`}>
        <div 
          className="bg-primary-600 h-8 rounded-full transition-all duration-500 ease-in-out relative overflow-hidden"
          style={{ width: `${progress}%` }}
        >
          {/* Striped pattern overlay */}
          <div 
            className="absolute inset-0 bg-white bg-opacity-20"
            style={{
              backgroundImage: `repeating-linear-gradient(
                45deg,
                transparent,
                transparent 8px,
                rgba(255,255,255,0.3) 8px,
                rgba(255,255,255,0.3) 16px
              )`
            }}
          />
          
          {showPercentage && progress > 0 && (
            <span className="absolute inset-0 flex items-center justify-center text-white font-medium text-lg">
              {Math.round(progress)}%
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;